import React, { useRef } from "react";
import Navbar from "../../components/landing/Navbar";
import Hero from "../../components/landing/Hero";
import Products from "../../components/landing/Products";
import Services from "../../components/landing/Services";
import Contact from "../../components/landing/Contact";
import Footer from "../../components/landing/Footer";

const LandingPage = () => {
  const productsRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const handleNavClick = (section) => {
    const sectionMap = {
      products: productsRef,
      // Route "pricing" clicks to the products section
      pricing: productsRef,
      services: servicesRef,
      contact: contactRef,
    };

    const targetRef = sectionMap[section];
    if (targetRef?.current) {
      targetRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="landing-page min-h-screen bg-background">
      <Navbar onNavClick={handleNavClick} />
      <Hero />
      <div ref={productsRef}>
        <Products />
      </div>
      <div ref={servicesRef}>
        <Services />
      </div>
      <div ref={contactRef}>
        <Contact />
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;

